import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { Button } from '@/shared/ui/buttons/Button';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { EmptyState } from '@/shared/ui/feedback/EmptyState';
import { ErrorState } from '@/shared/ui/feedback/ErrorState';
import { LifeBuoyIcon, SendIcon } from '@/shared/ui/icons';
import { useFaqs } from '@/entities/support';
import { WidgetsSupportFaqAccordion } from './FaqAccordion';

export const WidgetsSupportMain = () => {
  const { t } = useTranslation('support');
  const navigate = useNavigate();
  const faqs = useFaqs();

  return (
    <>
      <PageHeader title={t('title')} showBack backTo="/settings" />
      <div className="flex flex-col gap-5 p-4 md:mx-auto md:w-full md:max-w-2xl lg:p-6">
        <section className="flex flex-col gap-3">
          <h2 className="text-sm font-semibold text-ink-soft">{t('faqTitle')}</h2>
          {faqs.isLoading ? (
            <div className="flex justify-center py-8">
              <Spinner size="md" />
            </div>
          ) : faqs.isError ? (
            <ErrorState message={faqs.error.message} onRetry={() => void faqs.refetch()} />
          ) : faqs.data && faqs.data.length > 0 ? (
            <WidgetsSupportFaqAccordion faqs={faqs.data} />
          ) : (
            <EmptyState
              icon={<LifeBuoyIcon className="h-10 w-10" />}
              title={t('faqEmpty')}
            />
          )}
        </section>

        <section className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-card">
          <p className="text-sm text-ink-muted">{t('contactHint')}</p>
          <Button
            block
            leftIcon={<SendIcon className="h-4 w-4" />}
            onClick={() => navigate('/support/chat')}
          >
            {t('contact')}
          </Button>
        </section>
      </div>
    </>
  );
};
